import React, { CSSProperties } from 'react';
import { IModalContainerProps } from 'design-v2/common/ModalContainer/types';
import Modal from 'react-modal';
import './styles.global.css';

const NS = 'ModalContainer';

const ModalContainer = ({
  isOpen, onRequestClose, children, isMaxWidth, contentStyle, overlayStyle = {}, closeTimeoutMS,
  isWideVersion = false, wideRight = 30, wideWidth = 600, isDiaryBookingCreator = false
}: IModalContainerProps) => {
  const wideStyle = isWideVersion ? {
    inset: `50% ${wideRight}px auto calc(100% - ${(wideWidth * 1 - wideRight * 1)}px)`,
    transform: 'translate(0%, -50%)',
    marginRight: 'unset',
  } : {

  };

  const contentsStyle: Partial<CSSProperties> = {
    border: '1px solid #ccc', background: '#fff',
    overflow: 'auto', WebkitOverflowScrolling: 'touch',
    borderRadius: '8px', outline: 'none', padding: '10px',
    top: '50%', left: '50%', bottom: 'auto',
    marginRight: '-50%', transform: 'translate(-50%, -50%)',
    ...wideStyle,
    ...contentStyle,
  }

  if (!isMaxWidth) {
    contentsStyle.right = 'auto';
  }

  // to show the status modal inside the booking creator
  if (isDiaryBookingCreator) {
    
    contentsStyle.inset = `50% ${wideRight}px auto calc(100% - ${(wideWidth * 1 - wideRight * 1)}px)`;
    contentsStyle.transform = 'translate(0%, -50%)';
    contentsStyle.marginRight = 'unset';

    // to increase width
    contentsStyle.marginRight = '-60%';
  }

  return (
    <Modal
      closeTimeoutMS={closeTimeoutMS || closeTimeoutMS === 0 ? closeTimeoutMS : 200}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          zIndex: 200,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          ...overlayStyle,
        },
        content: contentsStyle,
      }}
    >
      {children}
    </Modal>
  );
};

export default ModalContainer;
